import { localStorageAdapter } from "commons/BrowserStorage";

export default class UserSegment {
  constructor(user) {
    this.user = user
    this.localStorageAdapter = localStorageAdapter()
    this.segmentStorageName = 'vidio_segments'
  }

  setSegmentState() {
    if (!window.isUserSignedIn) {
      this.clearStorageData()
      return
    }

    this.setStorageData()
  }

  clearStorageData(){
    this.localStorageAdapter.removeItem(this.segmentStorageName);
  }

  setStorageData(){
    this.localStorageAdapter.setItem(this.segmentStorageName, JSON.stringify(this.user.segments));
  }
}
